/* eslint-disable no-param-reassign */
import produce from 'immer';

// Constants
import { setItemsInLocalStorage, getItemFromLocalStorage } from 'utils/common';
import {
  FETCH_PRODUCT_STATUS_SUCCESS,
  FETCH_TEST_TOKEN_FROM_PROD_SUCCESS,
  RESEND_EMAIL_VERIFICATION_SUCCESS,
  VALIDATE_TOKEN_SUCCESS,
  ENABLE_LOADER,
  DISABLE_LOADER,
  UPDATE_GAMMA_TOKEN,
  FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS,
  UPDATE_SUBSCRIPTION_STATUS,
  SET_ACCOUNT_MANAGER_DETAILS,
  FETCH_QUICK_LINKS_SUCCESS,
  FETCH_HELPCENTER_FORM_SUCCESS,
  FETCH_HC_FORM_DATA_SUCCESS,
  CLOSE_HC_FORM,
  OPEN_HC_FORM,
  PAYOUT_PROTECT_INSIGHTS_SUCCESS,
  PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS,
  RISK_SHIELD_ACTIVE_STATUS_SUCCESS,
} from './constants';
import { getEPOSStatus } from './utils';

// Utils

export const initialState = {
  productStatus: {},
  testToken: '',
  emailStatus: {},
  isLoading: false,
  isPayoutNewDashboardEnabled: true,
  subscriptionsConfig: {},
  accountManagerList: [],
  quickLinks: [],
  helpCenter: {
    hcFormUrl: '',
    shortCode: '',
    orderId: 0,
    pageId: 0,
    serverData: {},
    isFormOpened: false,
  },
  kycStatus: {
    PG: {},
  },
  payoutProtectActiveStatusDetails: {},
  payoutProtectInsights: {},
  riskShieldActiveStatusDetails: {},
};

const landingPageReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_PRODUCT_STATUS_SUCCESS: {
        const { CSP, PG, EPOS } = action.payload;
        draft.productStatus = {
          ...action.payload,
          CG: CSP,
          ORDERS: PG,
          PF: PG,
          EPOS: getEPOSStatus({ PG, EPOS }),
        };
        break;
      }
      case FETCH_TEST_TOKEN_FROM_PROD_SUCCESS:
        draft.testToken = action.payload.token;

        if (action.payload.token) {
          setItemsInLocalStorage({
            testToken: action.payload.token,
            userFlow: 'dashboard',
          });
        }
        break;

      case RESEND_EMAIL_VERIFICATION_SUCCESS:
        draft.emailStatus = action.payload;
        break;
      case VALIDATE_TOKEN_SUCCESS: {
        const { merchantId, username, accountAlias, userId } = action.data;
        if (merchantId) setItemsInLocalStorage({ merchantId });
        if (userId) setItemsInLocalStorage({ userId });
        if (!getItemFromLocalStorage('email') && username && accountAlias)
          setItemsInLocalStorage({ email: `${username}@${accountAlias}` });
        break;
      }
      case UPDATE_SUBSCRIPTION_STATUS: {
        const { status } = action.data;
        draft.subscriptionsConfig = action.data;
        if (status === 'ACTIVE') {
          localStorage.setItem('subscriptionEnabled', true);
        } else localStorage.setItem('subscriptionEnabled', '');
        break;
      }
      case ENABLE_LOADER: {
        draft.isLoading = true;
        break;
      }
      case DISABLE_LOADER: {
        if (draft.isLoading) draft.isLoading = false;
        break;
      }

      case UPDATE_GAMMA_TOKEN: {
        try {
          const { token } = action.data;
          const cfTokenObj = JSON.parse(localStorage.getItem('cfToken'));
          cfTokenObj.test = { token };
          localStorage.setItem('gammaToken', token);
          localStorage.setItem('cfToken', JSON.stringify(cfTokenObj));
        } catch (err) {
          // eslint-disable-next-line no-console
          console.error(err);
        }
        break;
      }

      case FETCH_PAYOUT_DASHBOARD_CONFIG_SUCCESS:
        draft.isPayoutNewDashboardEnabled = action.payload.configValue;
        break;

      case SET_ACCOUNT_MANAGER_DETAILS:
        draft.accountManagerList = action.payload;
        break;

      case FETCH_QUICK_LINKS_SUCCESS: {
        try {
          const eventsData = action.payload;
          if (eventsData[0]) {
            draft.quickLinks = eventsData[0].EventsList;
          }
        } catch (err) {
          console.log(err);
        }
        break;
      }

      case FETCH_HELPCENTER_FORM_SUCCESS: {
        try {
          draft.helpCenter = {
            ...draft.helpCenter,
            hcFormUrl: action.payload?.form_url,
            shortCode: action.payload?.shortCode,
          };
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }

      case FETCH_HC_FORM_DATA_SUCCESS: {
        try {
          draft.helpCenter = {
            ...draft.helpCenter,
            orderId: action.payload?.orderId,
            pageId: action.payload?.pageId,
            serverData: action.payload,
          };
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }

      case CLOSE_HC_FORM: {
        try {
          draft.helpCenter = {
            ...draft.helpCenter,
            isFormOpened: false,
          };
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }

      case OPEN_HC_FORM: {
        try {
          draft.helpCenter = {
            ...draft.helpCenter,
            isFormOpened: true,
          };
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log(err);
        }
        break;
      }
      case PAYOUT_PROTECT_INSIGHTS_SUCCESS: {
        draft.payoutProtectInsights = action.payload;
        break;
      }
      case PAYOUT_PROTECT_ACTIVE_STATUS_SUCCESS: {
        draft.payoutProtectActiveStatusDetails = action.payload;
        break;
      }
      case RISK_SHIELD_ACTIVE_STATUS_SUCCESS: {
        draft.riskShieldActiveStatusDetails = action.payload;
        break;
      }

      default:
    }
  });

export default landingPageReducer;
